import React from 'react'
import HospitalLogin from '../../components/HospitalLogin/HospitalLogin'

function HospitalLoginPage() {
  return (
    <HospitalLogin/>
  )
}

export default HospitalLoginPage